
export const translatedMomentTitle = (swedishTitle: string, t: any) => {
    switch (swedishTitle) {
        case "Introduktion":
            return t("learning.result.introduction", "Introduction")
        case "Färdskrivaren":
            return t("learning.result.the_tachograph", "The tachograph")
        case "Förarkortet":
            return t("learning.result.the_drivers_license", "The driver's license")
        case "Övriga frågor":
            return t("learning.result.other_questions", "Other questions")
        case "Dygns- & veckovila":
            return t("learning.result.daily_weekly_rest", "Daily & weekly rest")
        case "Körtider & raster":
            return t("learning.result.driving_times_breaks", "Driving times & breaks")
        case "Klimatförändringar":
            return t("learning.result.climate_change", "Climate change")
        case "Vad kan du och ditt företag göra för att bidra till en minskad klimatpåverkan":
            return t(
                "learning.result.what_can_you_and_your_company_do",
                "What can you and your company do to contribute to a reduced climate impact?"
            )
        case "Miljöpåverkan från transporter":
            return t("learning.result.environmental_impact_from_transport", "Environmental impact from transport")
        case "Vad kan vi göra för att minska vår miljöpåverkan":
            return t(
                "learning.result.what_can_we_do_to_reduce_environmental_impact",
                "What can we do to reduce our environmental impact?"
            )
        case "Klimatsmarta drivmedel":
            return t("learning.result.climate_smart_fuels", "Climate-smart fuels")
        case "Mobilitetspaketet":
            return t("learning.result.mobility_package", "Mobility package")
        case "Vägarbetstidslagen":
            return t("learning.result.road_working_hours_act", "Road Working Hours Act")
        default:
            return swedishTitle
    }
}